var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultProfileMale(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99.0004,
    rx: 49.5,
    fill: "#EBEBEB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99.0004,
    rx: 49.5,
    stroke: "#D7D7D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8726 48.9087C39.3395 54.6905 44.035 60.9785 49.9993 60.9785C55.9636 60.9785 60.6591 54.6865 61.124 48.9087C63.2454 48.5986 64.2096 47.2822 64.2096 45.9738V41.9725C64.2096 40.7221 62.9815 39.8198 62.1796 39.3617V36.1967C63.1383 34.1541 63.0342 32.0274 61.8832 30.1868C60.2815 27.632 56.9278 26.1035 52.9144 26.1035C50.2916 26.1035 47.5287 26.7297 44.7049 27.9701C41.5116 28.0341 37.823 29.5086 37.823 35.9706V39.3617C37.0191 39.8198 35.793 40.7221 35.793 41.9725V45.9738C35.7889 47.2802 36.7512 48.5986 38.8726 48.9087Z",
    fill: "#C7C7C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0096 61.8465H56.0076V60.9785C54.2337 62.1397 52.2076 62.8506 50.0013 62.8506C47.797 62.8506 45.7689 62.1397 43.9951 60.9785V61.8465H41.993C36.1929 61.8465 29.9805 66.0816 29.9805 72.3891V72.8911C29.9805 73.4454 30.4289 73.8952 30.9815 73.8952H69.0211C69.5717 73.8952 70.0221 73.4454 70.0221 72.8911V72.3891C70.0221 66.0816 63.8077 61.8465 58.0096 61.8465Z",
    fill: "#C7C7C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultProfileMale);
export default __webpack_public_path__ + "static/media/Default Profile - Male.cc396440fffba5bd752e95bf9ba35465.svg";
export { ForwardRef as ReactComponent };